<template>
  <div class="base-field">
    <label v-if="label" class="base-field__label">
      <span v-if="isRequired" class="base-field_required">*</span>
      {{ label }}
    </label>
    <vue-tel-input
      v-model="phoneNumber"
      :defaultCountry="country"
      :mode="mode"
      :autoFormat="false"
      :inputOptions="{ placeholder: placeholder, type: type, showDialCode: false, validCharactersOnly: true }"
      @input="validateInput"
      @country-changed="getCodeCountry"
    ></vue-tel-input>
    <!-- <TransitionGroup>
      <div class="base-field__error" v-for="item of error" :key="item.$uid">
        <span class="base-field__error-message">{{ item.$message }}</span>
      </div>
    </TransitionGroup> -->
  </div>
</template>

<script setup>
import {
  computed,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from 'vue';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  mode: {
    type: String,
    default: "international",
  },
  country: {
    type: String,
    default: "US",
  },
  countryCode: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: "tel",
  },
  label: {
    type: String,
    default: "",
  },
  showSearchBox: {
    type: Boolean,
    default: false,
  },
  showDialCode: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "tel",
  },
  name: {
    type: String,
    default: "",
  },
  error: {
    type: Array,
    required: false,
  },
  isPassword: {
    type: Boolean,
    default: false,
  },
  isReadonly: {
    type: Boolean,
    default: false,
  },
  isTextCenter: {
    type: Boolean,
    default: false,
  },
  isGray: {
    type: Boolean,
    default: false,
  },
  isRequired: {
    type: Boolean,
    default: false,
  }
});
const emit = defineEmits(["country-changed"]);
const phoneNumber = ref("");;
const codeCountry = ref("");

const validateInput = (e) => {
  phoneNumber.value = phoneNumber.value.replace(/[^0-9+()-\s]/g, '');
}

const getCodeCountry = (country) => {
  const vueTelInput = document.querySelector('.vue-tel-input');
  const dropdown = vueTelInput?.querySelector('.vti__dropdown');
  vueTelInput?.querySelector('.vti__code').remove();
  dropdown.insertAdjacentHTML('afterend', `<div class="vti__code">+${country.dialCode}</div>`);
  emit('country-changed', country.dialCode);
};

onMounted(() => {
  insertCountryCode();
})

const insertCountryCode = () => {
  const vueTelInput = document.querySelector('.vue-tel-input');
  const dropdown = vueTelInput?.querySelector('.vti__dropdown');
  dropdown.insertAdjacentHTML('afterend', `<div class="vti__code">${codeCountry.value}</div>`);
}

</script>

<style lang="scss">
  .base-field {
    position: relative;
    font-size: 20px;
    margin-bottom: 10px;
    &__label {
      color: #A1A1AA;
      min-height: 30px;
      margin-bottom: 0;
      font-size: 14px;
    }
    &_required {
      color: #ff0000;
    }
    &__control {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 48px;
      padding: 0 15px;
      line-height: 145%;
      border: 1px solid rgba(23, 23, 25, 0.1);
      border-radius: 10px;
      transition: 0.2s ease-in-out;
      &:focus-within {
        border-color: #A1A1AA;
      }
    }
    &__input {
      position: relative;
      width: 100%;
      border: none;
      background: transparent;
      color: #9696a2;
      font-size: 14px;
      &::placeholder {
        color: #52525B;
        font-size: 16px;
      }
    }
    &__slot {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 0;
      height: 100%;
      span {
        width: 25px;
        &:before {
          font-size: 26px;
        }
      }
    }
    &__error {
      margin-top: 2px;
      border-radius: 10px;
      font-size: 12px;
      color: #F87171;
      padding: 2px 10px;
    }
    .ui-kit {
      &__icon {
        &::before {
          font-size: 20px;
        }
      }
    }
    &_is-password {
      &:focus-within {
        .ui-kit {
          &__icon {
            &::before {
              color: #A3E635;
            }
          }
        }
      }
    }
    &_is-readonly {
      .base-field__control {
        background: rgba(255, 255, 255, 0.05);
        cursor: not-allowed;
      }
      .base-field__input {
        &:read-only {
          color: #3F3F46;
          cursor: not-allowed;
        }
      }
    }
    &_is-border {
      .base-field__control{
        border: 1px solid rgba(255, 255, 255, 0.2);
        &:focus-within {
        border-color: #A1A1AA;
      }
      }
    }
    &_is-bottom-border-focus {
      gap: 8px;
      display: flex;
      flex-direction: column;
      .base-field__label {
        font-size: 12px;
        line-height: 16px;
        min-height: auto;
      }
      .base-field__control {
        background: var(--background-secondary);
        border: none;
        border-bottom: 1px solid transparent;
        transition: border-bottom 0.3s ease;
      }
      .base-field__control:focus-within {
        border: none;
        border-bottom: 1px solid var(--foreground-primary);
      }
      .base-field__input {
        font-size: 14px;
        line-height: 20px;
        color: var(--foreground-primary);
      }
      .base-field__input::placeholder {
        font-size: 14px;
        line-height: 20px;
        color: #52525B;
      }
      .base-field__error {
        color: #F87171;
        padding: 0;
      }
      .base-field__control:has(+ .base-field__error) {
        border: none;
        border-bottom: 1px solid #DC2626;
      }
    }
    &_is-search {
      .base-field__control {
        background: var(--search-bg);
      }
    }
    &_is-gray {
      .base-field__control {
        background: var(--background-secondary);
      }
    }
    &_is-center &__input {
      text-align: center;
    }
    &_is-center {
      min-width: 100px;
    }
    @include _380 {
      font-size: 14px;
      &__control {
        font-size: 14px;
        height: 44px;
      }
    }
  }
  .sign-in {
    &__field {
      &-dropdown {
        .vue-tel-input {
          position: relative;
          z-index: 100;
          height: 48px;
          border-radius: 10px;
          border: 1px solid #A1A1AA;
          .vti__input {
            background: var(--background-primary);
            border-radius: 0 10px 10px 0;
            color: var(--foreground-primary);
            font-size: 16px;
            padding-left: 10px;
            padding-right: 10px;
            font-family: "SF Pro Text", sans-serif;
            &::placeholder {
              color: var(--foreground-secondary);
              font-size: 14px;
              transition: opacity .3s ease-in-out;
            }
            &:focus::placeholder { opacity: 0; }
            &.vti__search_box {
              width: calc(100% - 10px);
              border-radius: 5px;
            }
          }
          .vti__phone { padding-left: 0; }
          .vti__dropdown {
            position: static;
            border-right: 1px solid #A1A1AA;
            &:hover,
            &.open { 
              background-color: transparent;
            }
            &:focus-visible { outline: none; }
            &-arrow { color: #A1A1AA; }
            &-list {
              width: 100%;
              border-radius: 10px;
              background-color: var(--background-primary);
              border: 1px solid #a1a1aa;
              &.below { top: calc(100% + 10px); }
            }
            &-item {
              padding: 10px;
              font-size: 13px;
              strong { font-weight: normal; }
              &.highlighted { background-color: rgba(80, 80, 80, 0.5); }
            }
          }
          .vti__code {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            padding: 0 8px 0 10px;
            opacity: 0.5;
            font-family: "SF Pro Text", sans-serif;
          }
          &:focus-within { box-shadow: none;}
        }
        &.form-field--dropdown {
          .vue-tel-input {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(60px);
            border: none;
            .vti {
              &__input {
                background: transparent;
              }
              &__phone {
                &::placeholder { color: rgba(255, 255, 255, 0.5); }
              }
              &__dropdown { 
                border-right: 1px solid rgba(142, 108, 134, 0.6);
                &-arrow { color: #fff; }
                &-list {
                  background: #8d386c;
                  backdrop-filter: blur(60px);
                  scrollbar-width: thin;
                  scrollbar-color: #930036 #d070b4;
                }
              }
            }
          }
        }
      }
    }
  }
</style>

